<template>
    <div class="app-container">
        <!-- 查询条件-->
        <div class="tt-form-box">
            <el-form ref="queryForm"
                     :model="queryParams"
                     :inline="true"
                     label-width="40px">
                <el-row class="mt10 ml10" >
                    <el-col :span="4" class="mb0">
                        <el-form-item label="学段">
                            <el-select clearable @change="changePeriod" v-model="queryParams.periodKey" placeholder="请选择">
                                <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" class="mb0">
                        <el-form-item label="年级">
                            <el-select clearable @change="changeGrade" v-model="queryParams.gradeKey" placeholder="请选择">
                                <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" class="mb0">
                        <el-form-item label="学科">
                            <el-select clearable @change="getStudioList" v-model="queryParams.subjectKey" placeholder="请选择">
                                <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6" class="mr0 mb0">
                        <el-form-item class="pull-right">
                            <el-input v-model="queryParams.groupName" placeholder="请输入名称" class="input-with-select">
                                <template #append>
                                    <el-button type="primary" @click="getStudioList" style="background-color: #0d55a4;color: #fff" icon="el-icon-search" />
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="mr0 mb0">
                        <el-button class="ml20 pull-right" type="primary" @click="downloadTemplate">下载导入成员模板</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="table-container bre9e mt15">
            <el-table  header-cell-class-name="bgf2" show-overflow-tooltip
                       height="calc(100vh - 170px)"  :data="studioList"
                       highlight-current-row>
                <el-table-column type="index" align="center" label="序号" width="60" />
                <el-table-column align="center" label="工作室名称" width="200" prop="groupName">
                    <template #default="scope">
                        <div :title="scope.row.groupName" style="color: #409efe;" class="text-one cursor"
                             @click="viewStudio(scope.row)">
                            {{ scope.row.groupName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="主持人" width="100" prop="leadName"/>
                <el-table-column align="center" label="主持人账号" width="200" prop="leadUsername"/>
                <el-table-column align="center" label="简报数量" width="80" prop="briefNum"/>
                <el-table-column align="center" label="文章数量" width="80" prop="articleNum"/>
                <el-table-column align="center" label="成果数量" width="80" prop="achieveNum"/>
                <el-table-column align="center" label="日志数量" width="80" prop="logNum"/>
                <el-table-column width="100" align="center" fixed="right" label="操作">
                    <template #default="scope">
                        <el-popover placement="bottom" trigger="click" :width="100" popper-style="padding: 5px 0 0">
                            <template #reference>
                                <el-button>操作</el-button>
                            </template>
                            <template #default>
                                <div>
                                    <div class="text-item">
                                        <el-text type="primary" @click="groupEdit(scope.row)">编辑</el-text>
                                    </div>
                                    <div class="text-item">
                                        <el-upload
                                          v-model:file-list="filesList"
                                          class="upload-demo"
                                          :action="serviceUrl+'/businessservice/teachingGroup/member/batchImport'"
                                          :on-change="handleChange"
                                          :headers="{ token }"
                                          :on-remove="handleRemove"
                                          :data="{ groupId: scope.row.groupId }"
                                          accept=".xlsx"
                                          :before-upload="beforeUpload"
                                        >
                                            <el-text>导入成员</el-text>
                                        </el-upload>
                                    </div>
                                    <div class="text-item"  >
                                        <el-text type="primary"  @click="memberListInfo(scope.row)">成员管理</el-text>
                                    </div>
                                    <div class="text-item">
                                        <el-text type="primary" @click="courseManager(scope.row)">课程资源管理</el-text>
                                    </div>
                                    <div class="text-item"  >
                                        <el-text type="primary" @click="goInfo(scope.row, 1)">工作简报</el-text>
                                    </div>
                                    <div class="text-item"  >
                                        <el-text type="primary" @click="goInfo(scope.row, 2)">教师文章</el-text>
                                    </div>
                                    <div class="text-item"  >
                                        <el-text type="primary" @click="goInfo(scope.row, 3)">成果展示</el-text>
                                    </div>
                                    <div class="text-item"  >
                                        <el-text type="primary" @click="goInfo(scope.row, 4)">工作日志</el-text>
                                    </div>
                                </div>
                            </template>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-dialog v-model="isStudioList" :title="studioTitle" width="765px">
            <div>
                <el-button type="primary" @click="createdInformation">新增{{infoTypeName}}</el-button>
            </div>
            <el-row>
                <el-table v-if="isStudioList" show-overflow-tooltip class="mt15"
                          height="50vh" border :data="infoList"
                          highlight-current-row>
                    <el-table-column type="index" label="序号" width="60" />
                    <el-table-column width="250" label="标题" prop="title">
                        <template #default="scope">
                            <div :title="scope.row.title" style="color: #409efe;" class="text-one cursor"
                                 @click="goDetail(scope.row)">
                                {{ scope.row.title }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" label="发布状态" prop="title">
                        <template #default="scope">
                            <div v-if="scope.row.isRelease===0"  class="text-one cursor">
                                未发布
                            </div>
                            <div v-if="scope.row.isRelease===1" style="color: #409efe;" class="text-one cursor">
                                已发布
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="80" label="作者" prop="trueName" />
                    <el-table-column width="80" label="阅读量" prop="readNum" />
                    <el-table-column width="140" label="创建时间" prop="createTime">
                        <template #default="scope">
                            <div>{{ timestampToTime(scope.row.createTime) }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" width="100" label="操作" class-name="small-padding fixed-width">

                        <template #default="scope">
                            <el-popover placement="bottom" trigger="click" :width="120" popper-style="padding: 5px 0 0">
                                <template #reference>
                                    <el-button>操作</el-button>
                                </template>
                                <template #default>
                                    <div>
                                        <div class="text-item">
                                            <el-text type="primary" @click="handleUpdate(scope.row)">编辑</el-text>
                                        </div>
                                        <div class="text-item" v-if="scope.row.isRelease===0">
                                            <el-text type="primary" @click="handleRelease(scope.row, scope.$index)">发布</el-text>
                                        </div>
                                        <div class="text-item">
                                            <el-popconfirm confirm-button-text="是" cancel-button-text="否"
                                                           icon-color="#626AEF" title="确定删除？" @confirm="handleDelete(scope.row, scope.$index)">
                                                <template #reference>
                                                    <el-text type="primary">删除</el-text>
                                                </template>
                                            </el-popconfirm>
                                        </div>
                                    </div>
                                </template>
                            </el-popover>
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>
        </el-dialog>

        <el-dialog v-model="isShowMember" :title="studioTitle" width="665px">
            <div>
                <el-button type="primary" @click="showGroupApply">申请审核</el-button>
            </div>
            <el-row>
                <el-table v-if="isShowMember" show-overflow-tooltip class="mt15"
                          height="50vh" border :data="memberList"
                          highlight-current-row>
                    <el-table-column type="index" label="序号" width="60" />
                    <el-table-column width="100" align="center" label="成员姓名" prop="memberName">
                    </el-table-column>
                    <el-table-column width="150" align="center" label="成员账号" prop="memberAccount">
                    </el-table-column>
                    <el-table-column width="100" align="center" label="角色" prop="memberRole" >
                        <template #default="scope">
                            <el-tag v-if="scope.row.memberRole===0">主持人</el-tag>
                            <el-tag v-if="scope.row.memberRole===1">管理员</el-tag>
                            <el-tag v-if="scope.row.memberRole===2">成员</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column width="200" align="center" label="所属组织" prop="orgName" >
                    </el-table-column>
                    <el-table-column width="160" align="center" label="加入时间" prop="joinTime">
                        <template #default="scope">
                            <div>{{ timestampToTime(scope.row.joinTime) }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right"  width="100" align="center" label="操作" class-name="small-padding fixed-width">

                        <template #default="scope">
                            <el-popover placement="bottom" trigger="click" :width="100" popper-style="padding: 5px 0 0">
                                <template #reference>
                                    <el-button>操作</el-button>
                                </template>
                                <template #default>
                                    <div>
                                        <div class="text-item" v-if="scope.row.memberRole===2&&(this.groupRole===0||this.role==1||this.role==2)">
                                            <el-text type="primary" @click="groupSetOrCancelManager(scope.row)">设置管理员</el-text>
                                        </div>
                                        <div class="text-item" v-if="scope.row.memberRole===1&&(this.groupRole===0||this.role==1||this.role==2)">
                                            <el-text type="primary" @click="groupSetOrCancelManager(scope.row)">取消管理员</el-text>
                                        </div>
                                        <el-popconfirm confirm-button-text="是" cancel-button-text="否"
                                                       icon-color="#626AEF" title="确定删除？" @confirm="handleDeleteMember(scope.row, scope.$index)">
                                            <template #reference>
                                                <div class="text-item" v-if="scope.row.memberRole===2">
                                                    <el-text type="primary">删除</el-text>
                                                </div>
                                            </template>
                                        </el-popconfirm>
                                    </div>
                                </template>
                            </el-popover>
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>
        </el-dialog>

        <el-dialog v-model="isApplyShow" :title="'申请审核'" width="815px">
            <el-row>
                <el-table v-if="isApplyShow" show-overflow-tooltip class="mt15"
                          height="50vh" border :data="applyList"
                          highlight-current-row>
                    <el-table-column type="index" label="序号" width="60" />
                    <el-table-column width="100" align="center" label="状态" prop="memberRole" >
                        <template #default="scope">
                            <el-tag v-if="scope.row.status===0">未审核</el-tag>
                            <el-tag type="success" v-if="scope.row.status===1">已通过</el-tag>
                            <el-tag type="danger" v-if="scope.row.status===2">已拒绝</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" align="center" label="申请人" prop="userTrueName">
                    </el-table-column>
                    <el-table-column width="160" align="center" label="申请时间" prop="applyTime">
                        <template #default="scope">
                            <div>{{ timestampToTime(scope.row.applyTime) }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" align="center" label="审核人" prop="checkUserName">
                    </el-table-column>
                    <el-table-column width="160" align="center" label="审核时间" prop="checkTime">
                        <template #default="scope">
                            <div>{{ timestampToTime(scope.row.checkTime) }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right"  width="120" align="center" label="操作" class-name="small-padding fixed-width">
                        <template #default="scope">
                            <el-button @click="agreeApply(scope.row)" v-if="scope.row.status===0"  type="success" link>通过</el-button>
                            <el-button @click="refuseApply(scope.row)" v-if="scope.row.status===0" type="danger" link>拒绝</el-button>
                        </template>

                    </el-table-column>
                </el-table>
            </el-row>
        </el-dialog>
    </div>
</template>

<script>
import {
    studioDelete,
    studioRelease,
    userManageStudioList,
    delGroupMember,
    setOrCancelManager,
  groupMemberList
} from "@/api/admin/studio";
import {queryDict} from "@/api/admin/public";
import {listApplyGroup,refuseApplyGroup,agreeApplyGroup} from "@/api/admin/group"
import {timestampToTime} from "@/utils/date";
import {download} from "@/api/adminservice/public";
import { serviceUrl } from "@/utils/global"
export default {
    name: "teaStudioManager",
    components: {},
    data() {
        return {
            serviceUrl,
            timestampToTime,
            token: this.$storage.get("token"),
            // 查询参数
            queryParams: {
                groupName:'',
                orgId:'',
                groupNature:'2',
                periodKey: '',
                gradeKey: '',
                subjectKey: '',
            },
            periodList: [],
            gradeList: [],
            subjectList: [],
            studioList:[],
            studioTitle: '',
            isStudioList: false,
            isShowMember: false,
            isApplyShow:false,
            infoList:[],
            infoType:1,
            infoTypeName:"咨询",
            groupId:'',
            memberList:[],
            applyList:[],
            groupRole:1,
            userId:JSON.parse(this.$storage.get("userInfo")).userId,
            role:this.$storage.get("role"),
            filesList: [],
        };
    },
    created() {
        this.getQueryDict();
        this.getStudioList();
    },
    activated() {},
    watch: {
        $route(to, from) {},
    },
    methods: {
        getQueryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
            })
        },
        changePeriod() {
            this.queryParams.gradeKey = '';
            this.queryParams.subjectKey = '';
            this.gradeList = [];
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.queryParams.periodKey === j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
            this.getStudioList()
        },
        changeGrade() {
            this.queryParams.subjectKey = '';
            this.subjectList = []
            this.periodList.forEach(e => {
                if (this.queryParams.periodKey === e.dictKey) {
                    e.childrenList.forEach(j => {
                        if (this.queryParams.gradeKey === j.dictKey) {
                            this.subjectList = j.childrenList;
                        }
                    })
                }
            })
            this.getStudioList()
        },
        getStudioList() {
            userManageStudioList(this.queryParams).then(res => {
                this.studioList = res.data.data;
                this.loading = false;
            });
        },
        createdInformation() {
            const type = this.infoType;
            this.$router.push({
                path: "/studioInformation",
                query: {
                    groupId: this.groupId,
                    type,
                    isTeachStudioList: 1
                }
            });
        },
        viewStudio(item) {
            this.$router.push({
                path: "/studioinfo",
                query: {
                    groupId: item.groupId,
                }
            });
        },
        goDetail(row) {
            this.$router.push({
                path: "/studioDetail",
                query: {
                    infoId: row.infoId,
                }
            });
        },
        groupEdit(row){
            this.$router.push({
                path: "/groupEdit",
                query: {
                    groupId: row.groupId,
                }
            });
        },
        goInfo(row, type) {
            this.infoType = type;
            this.groupId = row.groupId;
            if (type == 3) {
                this.isStudioList = true;
                this.studioTitle = row.groupName + '成果'
                this.infoTypeName = '成果'
                this.infoList = row.achieveList;
            } else if (type == 4) {
                this.isStudioList = true;
                this.studioTitle = row.groupName + '日志'
                this.infoList = row.logList;
                this.infoTypeName = '日志'
            } else if (type == 2) {
                this.isStudioList = true;
                this.studioTitle = row.groupName + '文章'
                this.infoList = row.articleList;
                this.infoTypeName = '文章'
            } else if (type == 1) {
                this.isStudioList = true;
                this.studioTitle = row.groupName + '工作简报'
                this.infoList = row.briefList;
                this.infoTypeName = '简报'
            }
        },
        memberListInfo(row){
            this.studioTitle = row.groupName + '成员'
            this.applyList = []
            listApplyGroup({groupId:row.groupId}).then(res => {
                if (res.data.code === 1) {
                    this.applyList = res.data.data;
                }
            })
            groupMemberList({groupId:row.groupId}).then(res => {
                if (res.data.code === 1) {
                    this.memberList = res.data.data;
                    this.judgeMemberRole(this.memberList)
                }
            })
            this.isShowMember = true;
        },
        judgeMemberRole(ml){
            if (ml){
                ml.forEach(e => {
                    if (e.memberUserId === this.userId) {
                        this.groupRole = e.memberRole;
                    }
                })
            }
        },
        showGroupApply(){
            this.isApplyShow = true;
        },
        handleUpdate(row) {
            this.$router.push({
                path: "/studioInformation",
                query: {
                    groupId: row.groupId,
                    type: row.type,
                    infoId: row.infoId,
                    isTeachStudioList: 1,
                }
            });
        },
        handleDelete(row, index) {
            studioDelete({ infoId: row.infoId }).then(res => {
                if (res.data.code == 1) {
                    this.$message.success("删除成功");
                    this.infoList.splice(index, 1)
                    this.getStudioList()
                } else {
                    this.$message.error("删除失败");
                }
            })
        },
        handleDeleteMember(row, index){
            delGroupMember({ memberId: row.memberId }).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("删除成功");
                    this.memberList.splice(index, 1)
                    this.getStudioList()
                } else {
                    this.$message.error("删除失败");
                }
            })
        },
        groupSetOrCancelManager(row){
            setOrCancelManager({ memberId: row.memberId }).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.getStudioList()
                    groupMemberList({groupId:row.groupId}).then(res => {
                        if (res.data.code === 1) {
                            this.memberList = res.data.data;
                        }
                    })
                } else {
                    this.$message.error("操作失败");
                }
            })
        },
        handleRelease(row, index){
            studioRelease({ infoId: row.infoId }).then(res => {
                if (res.data.code == 1) {
                    this.$message.success("发布成功");
                    this.infoList[index].isRelease = 1;
                    this.getStudioList()
                } else {
                    this.$message.error("发布失败");
                }
            })
        },
        refuseApply(row){
            refuseApplyGroup({applyId:row.applyId}).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功")
                    listApplyGroup({groupId:row.groupId}).then(res => {
                        if (res.data.code === 1) {
                            this.applyList = res.data.data;
                        }
                    })
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        agreeApply(row){
            agreeApplyGroup({applyId:row.applyId}).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功")
                    listApplyGroup({groupId:row.groupId}).then(res => {
                        if (res.data.code === 1) {
                            this.applyList = res.data.data;
                        }
                    })
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        courseManager(row) {
            this.$router.push({
                path: "/studioCourseManager",
                query: {
                    groupId: row.groupId,
                }
            });
        },
        downloadTemplate() {
            download('https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/excel/%E6%95%99%E7%A0%94%E7%BB%84%E6%88%90%E5%91%98%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx', '群组导入模板')
        },
        handleChange(e, type) {
            if (e.response) {
                if (e.response.code == 1) {
                    this.$message.success('导入成功')
                    this.filesList = [];
                    this.getStudioList()
                } else {
                    if (e.response.msg) {
                        this.$message.error(e.response.msg)
                    } else {
                        this.$message.error('导入失败')
                    }
                }
            }
            if (e.status == 'fail') {
                this.$message.error('导入失败')
            }
        },
        handleRemove(file, uploadFiles) {
        },
        beforeUpload(file, uploadFiles) {
        },
    }
};
</script>
<style scoped>
.app-container{
    background-color: #fff;
    margin-top: 10px;
    margin-left: 10px;
}
.tt-form-box{
    width: 98%;
    height: 40px;
    margin: auto;
    border-bottom: 2px solid #0d55a4;
}
.table-container{
    width: 98%;
    margin: auto;
    padding-top: 10px;
    box-sizing: border-box;
}
</style>